import { jwtDecode } from "jwt-decode";
const getToken = () => {
	return localStorage.getItem("vue_token");
};

const getProcessedToken = () => {
	try {
		const decoded = jwtDecode(getCookieToken());
		return decoded.sub;
	} catch (error) {
		return null;
	}
};

const getRefreshToken = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "refreshToken") {
				return cur[1];
			}
		}
	}
	return null;
};
const getUserID = () => {
	try {
		const decoded = jwtDecode(getToken());
		return decoded.sub;
	} catch (error) {
		return null;
	}
};
// const checkAccess = (project) => {
//     if (document.cookie.length > 0) {
//       let data = document.cookie.split(";");
//       for (let i in data) {
//         let cur = data[i].split("=");
//         if (cur[0].trim() === project) {
//           if (cur[1] === 'no-access') {
//             return false;
//           } else {
//             return true;
//           }
//         }
//       }
//     }
// };
const checkAccess = () => {
	const projects = ["assessment", "candidate", "recruitment", "training"];
	let accessCount = 0;

	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		let cookieMap = {};

		data.forEach((cookie) => {
			let [key, value] = cookie.split("=");
			cookieMap[key.trim()] = value ? value.trim() : "";
		});

		projects.forEach((project) => {
			if (cookieMap[project] && cookieMap[project] !== "no-access") {
				accessCount++;
				console.log(accessCount);
			}
		});

		// if (
		// 	cookieMap["collegeDashboard"] &&
		// 	cookieMap["collegeDashboard"] !== "no-access"
		// ) {
		// 	accessCount++;
		// }
	}
	console.log(accessCount);
	return accessCount > 0;
};
const checkTokenExpiry = () => {
	let cookieToken = getCookieToken();
	if (cookieToken) {
		let decoded = jwtDecode(cookieToken);
		let time = null;
		let currentTime = Math.floor(new Date().getTime());
		if (currentTime >= decoded.exp * 1000) {
			time = false;
		} else {
			time = true;
		}
		console.log(time);
		return true;
	}
};
const getCookieToken = () => {
	const cookies = document.cookie.split("; ");
	for (let i = 0; i < cookies.length; i++) {
		const [key, value] = cookies[i].split("=");
		if (key === "accessToken") return value;
	}
	return null;
};
const getName = () => {
	try {
		const decoded = jwtDecode(getToken());
		return decoded.name;
	} catch (error) {
		return null;
	}
};
const getEmail = () => {
	try {
		const decoded = jwtDecode(getToken());
		return decoded.email;
	} catch (error) {
		return null;
	}
};

const clearCookies = () => {
	const cookies = document.cookie.split(";");
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i];
		const eqPos = cookie.indexOf("=");
		const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
		document.cookie =
			name.trim() +
			"=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;domain=hire3x.com;";
		// name.trim() + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
	}
};

const getMobileToken = () => {
	if (document.cookie.length > 0) {
		let data = document.cookie.split(";");
		for (let i in data) {
			let cur = data[i].split("=");
			if (cur[0].trim() === "mobileToken") {
				return JSON.parse(cur[1]).token;
			}
		}
	}
	return null;
};

export { getToken, getEmail, getUserID, checkAccess, getName, checkTokenExpiry, getCookieToken, clearCookies, getRefreshToken, getProcessedToken, getMobileToken };
